export const spacingBase = 8;
export const mlPagePadding = `0 ${spacingBase * 5}px`;
